const $ = require('jquery');

$('.wp-block-file a').each(function() {
	//$(this).prop('download', true);
});
